export default __webpack_public_path__ + "static/media/CNo.68-6.1ec1f0de.jpg";